import { cateringOrderClient } from '@/services/clients'

export default {
  url(latitude, longitude, isDelivery) {
    return cateringOrderClient.get('/googlemaps/url', {
      latitude,
      longitude,
      isDelivery,
    })
  },
}
